const routes = {
  login: '/login',
  menu: '/menu',
  menuItems: '/menu/items',
  menuItemDetails: '/menu/items/:itemId',
  categoryEdit: '/category/edit',
  subcategoryEdit: '/subcategory/edit',
  itemEdit: '/item/edit',
  sizeEdit: '/size/edit',
  categoriesOrder: '/categories/order',
  optionsList: '/options-list',
  optionEdit: '/option/edit',
  availabilitiesList: '/availabilities-list',
  scheduling: '/scheduling',
  reservations: '/reservations',
  bookingWidget: '/book',
};

export default routes;
